import { useMemo } from 'react';

import useStateHandler from '@/hooks/useStateHandler';
import MeasuredOrderVirtualList from '@/pages/orders/components/MeasuredOrderVirtualList';
import OrderCard from '@/shared-components/cards/components/OrderCard';

import AddShippingDetailsCard from './components/AddShippingDetailsCard';

import './index.css';

export default function VirtualList({ fetchData, setFetchData, loadMoreData }) {
  const { state, stateHandler, cacheHandler } = useStateHandler();
  const isGallery = state.user_session.user_type === "gallery";
  const hasPendingShippingAlert = useMemo(() => {
    if (isGallery) {
      return false;
    }

    return (fetchData?.data ?? []).some((order) => {
      const shippingStatus = order?.order_shipping_address?.shipping_status
        ?? order?.order_status
        ?? order?.status
        ?? null;
      const hasShippingAddress = order?.order_shipping_address?.address_name &&
        order?.order_shipping_address?.address_street &&
        order?.order_shipping_address?.address_country;
      const orderBuyerId = order?.order_buyer?._id ?? order?.order_buyer ?? null;
      return shippingStatus === "payment_pending" &&
        !hasShippingAddress &&
        state.user_session?._id &&
        orderBuyerId &&
        String(orderBuyerId) === String(state.user_session._id);
    });
  }, [fetchData?.data, state.user_session?._id, state.user_session?.user_type]);

  function onAddShippingDetails(orderId) {
    setFetchData({
      ...fetchData,
      totalDocs: fetchData.totalDocs - 1,
      data: fetchData.data.filter(order=>order._id !== orderId)
    });

    cacheHandler.triggerAction("PROVIDE_SHIPPING_NUMBER");

    stateHandler.set("temporalPopup", {
      text: "Shipping details updated for the order!", 
    });
  }

  return (
    <MeasuredOrderVirtualList
      orders={fetchData.data}
      totalOrders={fetchData.totalDocs}
      loadMoreData={loadMoreData}
      defaultRowHeight={isGallery ? 450 : 244}
      layoutVersion={hasPendingShippingAlert}
      renderOrder={(order) => (
        isGallery ? (
          <AddShippingDetailsCard orderData={order} onAddShippingDetails={onAddShippingDetails}/>
        ) : (
          <OrderCard orderData={order} navigateToView/>
        )
      )}
    />
  );
}
